import { defineMessages } from 'react-intl';

export default defineMessages({
    searchForTopic: {
        id: 'faq.directive.Search for a topic',
        defaultMessage: 'Search for a topic',
    },
    generalBilling: {
        id: 'faq.sections.General Billing',
        defaultMessage: 'General Billing',
    },
    claim: {
        id: 'faq.sections.Claim',
        defaultMessage: 'Claim',
    },
    customizeFAQContent: {
        id: 'faq.sections.How to customize the FAQ content',
        defaultMessage: 'How to customize the FAQ content',
    },
    frequentlyAskedQuestions: {
        id: 'faq.directive.Frequently Asked Questions',
        defaultMessage: 'Frequently Asked Questions',
    },
    differentWaysToPay: {
        id: 'faq.topics.payment_methods.question',
        defaultMessage: 'What are the different ways to pay for my insurance policy?',
    },
    creditCardPayment: {
        id: 'faq.topics.payment_methods.link.To make a one time credit card payment, please click here.',
        defaultMessage: 'To make a one time credit card payment, please click here.',
    },
    correctBillingMistake: {
        id: 'faq.topics.billing_mistake.question',
        defaultMessage: 'How can I correct a billing mistake made in the last three months?',
    },
    reportBillingMistake: {
        id: 'faq.topics.billing_mistake.link.To report a billing mistake on your last statement, please click here.',
        defaultMessage: 'To report a billing mistake on your last statement, please click here.',
    },
    claimProcess: {
        id: 'faq.topics.when_to_claim.question',
        defaultMessage: 'When is it best to begin the claim process after something happened to my house?',
    },
    renewlaCostInFuture: {
        id: 'faq.topics.claim_rate_increase.question',
        defaultMessage: 'In the event of a claim against the insurance policy, will my insurance costs increase at renewal or at any time in the future?',
    },
    deductible: {
        id: 'faq.topics.deductible_payment.question',
        defaultMessage: 'Under what circumstances would I have to pay a deductible when making a claim?',
    },
    FaqTopic: {
        id: 'faq.topics.show_video.question',
        defaultMessage: 'How to make a youtube video appear in the answer for a FAQ topic?',
    },
    clickableLink: {
        id: 'faq.topics.show_link.question',
        defaultMessage: 'How can I show a clickable link appear in the answer for a FAQ topic?',
    },
    customText: {
        id: 'faq.topics.show_link_text.question',
        defaultMessage: 'How can I show custom text that can be clicked to access a link in the answer for a FAQ topic?',
    },
    clickedText: {
        id: 'faq.topics.show_link_text.This text can be clicked.',
        defaultMessage: 'This text can be clicked.',
    },
    formattingQuestion: {
        id: 'faq.topics.formatting.question',
        defaultMessage: 'How can I customize the format of the question and answer elements for a given topic?',
    },
    bankTransfer: {
        id: 'faq.topics.payment_methods.answer.long',
        defaultMessage: 'Payments can be made using a major credit/debit card or a bank transfer.',
    },
    billngMistake: {
        id: 'faq.topics.billing_mistake.answer.long',
        defaultMessage: 'Billing mistakes should be brought to our attention as soon as they are found to ensure that they are promptly corrected. Please make sure to gather as much information about the mistake such as the date and amounts. You may then contact us through email, chat or phone.',
    },
    eventClaim: {
        id: 'faq.topics.when_to_claim.answer.long',
        defaultMessage: 'In order for us to best serve you in time of need, please notify us of any event that may lead to a claim as soon as you can reasonably expect to make a claim against your insurance policy.',
    },
    increasedRates: {
        id: 'faq.topics.claim_rate_increase.answer.long',
        defaultMessage: 'Filing a claim will not necessarily result in increased rates. Several factors are considered when rating a policy renewal.',
    },
    deductibleAmountasedRates: {
        id: 'faq.topics.deductible_payment.answer.long',
        defaultMessage: 'If the policy stipulates a deductible amount, the deductible amount must be covered when making a claim against the policy.',
    },
    navigateToVideo: {
        id: 'faq.topics.show_video.answer.long',
        defaultMessage: 'Using your browser, navigate to the youtube video that you would like to show. Copy the hash part of the url, for example in the following URL https://www.youtube.com/watch?v=XHB609to9dg the video hash is XHB609to9dg. Insert the video hash inside the topic object under a key named videoId.',
    },
    navigateToExternalLink: {
        id: 'faq.topics.show_link.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    navigateToExternalLinkText: {
        id: 'faq.topics.show_link_text.answer.long',
        defaultMessage: 'Using your browser, navigate to the external link that you would like to show. Copy the url from the browser and insert into a new object as the value for the key url.',
    },
    customFaq: {
        id: 'faq.topics.formatting.answer.long',
        defaultMessage: 'You can use html markup to customize the FAQ such as:<h2>A list example</h2><ul><li><a target="_blank" href="http://example.com">The first item is a link</li><li>The second item is <strong>an emphasis</strong></li><li>The third item is a spinner image <img src="throbber.gif" /></li><li>The fourth item is an escape of the tag &lt;div&gt;</li></ul>',
    },
    typeQuestion: {
        id: 'faq.directive.Start typing your question...',
        defaultMessage: 'Start typing your question...',
    },
    sections: {
        id: 'faq.directive.Sections',
        defaultMessage: 'Sections',
    },
    noMatchingError: {
        id: 'faq.directive.No matching results found',
        defaultMessage: 'No matching results found',
    },
    aboutThePortal: {
        id: 'faq.sections.About the Portal',
        defaultMessage: 'About the Portal',
    },
    purposeOfClaimPortal: {
        id: 'faq.topics.about_portal_for_ph.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalQuestion: {
        id: 'faq.topics.about_portal_for_ph.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Policy Holders?',
    },
    purposeOfClaimPortalShortAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.short',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business',
    },
    purposeOfClaimPortalLongAnswer: {
        id: 'faq.topics.about_portal_for_ph.answer.long',
        defaultMessage: 'Claim Portal for Policyholders can be used to file a claim against a policy based on one or more lines of business.',
    },
    purposeOfClaimPortalProducer: {
        id: 'faq.topics.about_portal_for_producers.inline_question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalQuestionProducer: {
        id: 'faq.topics.about_portal_for_producers.question',
        defaultMessage: 'What is the purpose of the Claim Portal for Agents?',
    },
    purposeOfClaimPortalShortAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.short',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured.',
    },
    purposeOfClaimPortalLongAnswerProducer: {
        id: 'faq.topics.about_portal_for_producers.answer.long',
        defaultMessage: 'The Claim Portal for Agents is intended for agents that can act on behalf of the insured and perform actions like filing a new claim or verifying the status of an existing one.',
    },
    paperCopyQuestion: {
        id: 'faq.topics.paperCopy.question',
        defaultMessage: 'Can I use my digital Liability Pink Slip in place of the paper copy?',
    },
    paperCopyAnswer: {
        id: 'faq.topics.paperCopy.answer.long',
        defaultMessage: 'Digital insurance cards are not yet valid in every Canadian province or territory. Depending on your location, you may require a paper-based proof of insurance card. Please carry your paper copy with you.',
    },
    changesQuestion: {
        id: 'faq.topics.changes.question',
        defaultMessage: 'I made changes to my policy, why don’t I see them on the Portal?',
    },
    changesAnswer: {
        id: 'faq.topics.changes.answer.long',
        defaultMessage: 'There can be a delay between our insurance processing system and the information displayed in the Portal. This means a change might not display in the Portal right away.',
    },
    coveragesQuestion: {
        id: 'faq.topics.coverages.question',
        defaultMessage: 'One of my policy’s coverages is not showing on the Portal. Why?',
    },
    coveragesAnswer: {
        id: 'faq.topics.coverages.answer.long',
        defaultMessage: 'The portal does not show all the information contained on your insurance declaration page. Recommendation is to open the policy document for the specific policy under the Policy Documents Section. If you have any questions, please contact your Agent or Broker.',
    },
    creditCardQuestion: {
        id: 'faq.topics.creditCard.question',
        defaultMessage: 'Can I pay with Credit Card?',
    },
    creditCardAnswer: {
        id: 'faq.topics.creditCard.answer.long',
        defaultMessage: 'Credit card is not accepted as payment with Ayr Famers Mutual Insurance Company, to see all payment options:',
    },
    bankingQuestion: {
        id: 'faq.topics.banking.question',
        defaultMessage: 'How do I pay my bill though online banking? ',
    },
    bankingAnswer: {
        id: 'faq.topics.banking.answer.long',
        defaultMessage: 'Please click the below link to see all payment options.',
    },
    insuranceCopyQuestion: {
        id: 'faq.topics.insuranceCopy.question',
        defaultMessage: 'How can I get the most recent copy of my insurance policy?',
    },
    insuranceCopyAnswer: {
        id: 'faq.topics.insuranceCopy.answer.long',
        defaultMessage: 'The Policy Document section should have the most recent copy of your declaration page. If you are having any issues, please reach out to your Agent or Broker.',
    },
    dragDropQuestion: {
        id: 'faq.topics.dragDrop.question',
        defaultMessage: 'What is the intent of the drag and drop files / upload file in the My Policy Documents section? How would I know what files to upload and why?',
    },
    dragDropAnswer: {
        id: 'faq.topics.dragDrop.answer.long',
        defaultMessage: 'This allows you to upload any documents to your policy that were requested by your Agent or Broker. An example of this would be if your Agent or Broker has asked you to send a copy of your vehicle Ownership. </br> Please note: Insurance coverage CANNOT be bound unless you speak directly with your licensed Ayr Farmers Mutual Insurance Agent or Broker. Sending a message, uploading a document/photo, or leaving a voicemail does not constitute insurance coverage as being in effect.',
    },
    paymentMethodQuestion: {
        id: 'faq.topics.paymentMethod.question',
        defaultMessage: 'Can I update my insurance or payment method through this portal?',
    },
    paymentMethodAnswer: {
        id: 'faq.topics.paymentMethod.answer.long',
        defaultMessage: 'This portal is currently for reference purposes only, any changes or updates to your policy must be processed through your Agent or Broker.',
    },
    forgotPasswordQuestion: {
        id: 'faq.topics.forgotPassword.question',
        defaultMessage: 'I forgot my password, how do I reset it?',
    },
    forgotPasswordAnswer: {
        id: 'faq.topics.forgotPassword.answer.long',
        defaultMessage: 'You can reset your password by clicking on the Password Reset Link on the Login Page.',
    },
    personalAccountQuestion: {
        id: 'faq.topics.personalAccount.question',
        defaultMessage: 'How do I update my personal account or Portal information?',
    },
    personalAccountAnswer: {
        id: 'faq.topics.personalAccount.answer.long',
        defaultMessage: 'You can use the send message function to request changes. Your message will be sent to your agent, who will process the change and send you confirmation once it has been completed.',
    },
    paymentLink: {
        id: 'faq.topics.paymentLink.link.Please click here.',
        defaultMessage: 'Please click here.',
    },
    accessPoliciesQuestion: {
        id: 'faq.topics.accessPolicies.question',
        defaultMessage: 'How do I update who has access to my policies in this portal?',
    },
    accessPoliciesAnswer: {
        id: 'faq.topics.accessPolicies.answer.long',
        defaultMessage: 'For any changes to authorized users that have access to the policies on your portal please email PortalAdmin@ayrmutual.com',
    },
    technicalSupportQuestion: {
        id: 'faq.topics.technicalSupport.question',
        defaultMessage: 'I need technical support about using this portal, who can I contact?',
    },
    technicalSupportAnswer: {
        id: 'faq.topics.technicalSupport.answer.long',
        defaultMessage: 'If you need technical support, please email PortalAdmin@ayrmutual.com, someone will be able to address your questions within 24 hours during business days',
    },
    paymentOption: {
        id: 'faq.topics.technicalSupport.Payment Options',
        defaultMessage: 'Payment Options',
    }
});
